export default "__VITE_ASSET__HTHgJPZ7__"